import { NextRouter } from "next/router";
import { useState, useEffect, SetStateAction, Dispatch } from "react";
import { client } from "./logger";

type Value = string | Array<string> | null;

type Data = string | string[] | undefined;

const internalParseData = (
  data: Data
): {
  [key: string]: string | Array<string>;
} => {
  let prefilledData: {
    [key: string]: string;
  } = {};
  try {
    if (data && typeof data === "string") {
      prefilledData = JSON.parse(window.atob(data));
    }
  } catch (e) {
    client.log("Invalid prefilled data (perhaps too long url?)", e);
  }
  return prefilledData;
};

const getPrefilledData = (field: string, data: Data): Value => {
  const prefilledData = internalParseData(data);
  if (typeof prefilledData[field] === "undefined") {
    return "";
  }
  return prefilledData[field];
};

const getPrefilledGroupData = (field: string, data: Data): Array<Value> => {
  const prefilledData = internalParseData(data);

  let result: Array<Value> = [];
  Object.keys(prefilledData).forEach((key) => {
    if (key.indexOf(field) !== -1) {
      let values: Array<string> | string = prefilledData[key];
      if (Array.isArray(values)) {
        values = values.filter((val) => val.length);
      }
      if (values.length) {
        result.push(values);
      }
    }
  });
  return result;
};

const canSkipPrefilledGroup = (
  group: string,
  data: Data,
  expectedValuesDivisor: number
) => {
  let shouldSkip = false;
  const prefilledTransactionCurrency = getPrefilledGroupData(group, data);
  if (
    data &&
    prefilledTransactionCurrency.length % expectedValuesDivisor == 0
  ) {
    shouldSkip = true;
  }
  return shouldSkip;
};

function usePrefilledStatus(
  field: string,
  prefilledData: Data,
  cb: Dispatch<SetStateAction<Value>>
) {
  const [value, setValue] = useState<Value>(null);

  useEffect(() => {
    const prefilled = getPrefilledData(field, prefilledData);
    setValue(prefilled);
    cb(prefilled);
  }, [cb, field, prefilledData]);

  return value;
}

function hidePrefillQueryString(data: Data, router: NextRouter): void {
  if (data) {
    router.replace(window.location.href.replace(/&data=[^&]+/g, ""));
  }
}

export {
  usePrefilledStatus,
  getPrefilledData,
  canSkipPrefilledGroup,
  hidePrefillQueryString,
};
